import { alpha } from "@material-ui/core"
import DynamicStrokeCircle from "./DynamicStrokeCircle"
import simpleCircleGraphics, { simpleCircleGraphicsOptions } from "./SimpleCircleGraphics"

export type progressCircleGraphicsOptions = {
	progress: (() => number),
	arcColor: string
} & simpleCircleGraphicsOptions

const progressCircleGraphics = ({
	progress,
	arcColor,

	...rest
}: progressCircleGraphicsOptions) => {
	const group = simpleCircleGraphics(rest)

	const { size } = rest

	const strokeWidth = 8

	const arc = new DynamicStrokeCircle({
		left: group.left,
		top: group.top,
		fill: 'transparent',
		stroke: alpha(arcColor, 0.25),
		strokeWidth: strokeWidth,
		originX: 'center',
		originY: 'center',
		radius: (size / 2) - strokeWidth,
		startAngle: (-Math.PI / 2),
		endAngle: () => ((Math.PI * 2) * progress()) - (Math.PI / 2)
	})

	group.addWithUpdate(arc)

	group.addComponent('arc', arc)

	return group
}

export default progressCircleGraphics